import React from "react";
import PolicyLayout from "./PolicyLayout";
import { highlightKeyInfo, linkifyNbfc } from "./NbfcLink";
import { CUSTOMER_SUPPORT_HOURS, VOICE_SUPPORT_HOURS } from "../utils/supportHours";

const GrievanceRedressalPolicy: React.FC = () => {
  const policySections = [
    {
      title: `${import.meta.env.VITE_COMPANY_NBFC} (Brand Name: ${import.meta.env.VITE_COMPANY_NAME})`,
      content: `PURPOSE

Customer complaints constitute an important voice of customer, and this policy details complaint handling through a structured grievance redressal framework. Complaint redressal is supported by a review mechanism, to minimize the recurrence of similar issues in future.

The Grievance Redressal policy follows the following principles:`,
      list: [
        "Customers are treated fairly.",
        "Complaints raised by customers are dealt with courtesy and in a timely manner.",
        "Customers are informed of avenues to escalate their complaints within the organization, and their rights if they are not satisfied with the resolution of their complaints.",
        "The employees work in good faith and without prejudice, towards the interests of the customers.",
      ],
    },
    {
      title: "INTERNAL MACHINERY TO HANDLE CUSTOMER COMPLAINTS",
      content:
        "The Company has developed the best-in-class CRM system to ensure the timely resolution of grievances. The system captures the complaints; follows TATs based on the nature of the query and escalates issues on the basis of predefined TATs and as per the escalation matrix. The customer service will be responsible for the resolution of complaints/grievances to the customer's satisfaction within a period of seven (7) business days. Every attempt will be made to offer the customer suitable and appropriate alternate solutions wherever possible. However, if the customer continues to remain dissatisfied with the resolution, (s)he can escalate the issue through the grievance redressal mechanism as referred below.",
    },
    {
      title: "TIME FRAME",
      content:
        "Suitable timelines of seven (7) business days have been set for every complaint depending upon the investigations which would be involved in resolving the same. Complaints are suitably acknowledged on receipt and the customers are informed of delays if any, in the resolution.",
    },
    {
      title: "REVIEW AND MONITORING",
      content:
        "Periodic review of monitoring of complaints, TATs, nature of complaints will be done to ensure that process loopholes, if any, are plugged and trends are checked.",
    },
    {
      title: "TOUCH POINTS",
      content:
        'Customer complaints constitute an important voice of customer, and this policy details complaint handling through a structured grievance redressal framework. Complaint redressal is supported by a review mechanism, to minimize the recurrence of similar issues in future. The customer can raise their concerns pertaining to the LOANINSECONDS Mobile Application (hereinafter referred as "Platform") or to the lender who provides loan to the customer through the Platform in the following matters:',
    },
    {
      title: "GRIEVANCE REDRESSAL MECHANISM OF THE PLATFORM",
      content: `Customers can raise their concerns pertaining to the Platform, Repayment schedule, Processing Fee and / or any other charges or any other concern related to the product to authorised representatives of the Company as below.

Below are the various ways/modes through which the customers can register their complaints/queries/enquiries. The customers have the following ways of approaching the Company as per details mentioned below:`,
    },
    {
      title: "Voice Support",
      content: "The customer can call us at Customer Care at 8796755546 between 09:00 AM to 7:00 PM from Monday to Saturday.",
    },
    {
      title: "Email Support",
      content: `Please write to us at support@loaninseconds.com (Please ensure to mention your loan account number and contact number in the email).

The customer will receive a response from the team within 7 business days but there would be instances wherein the team may even take longer to respond/reply.

A customer can escalate the matter to info@loaninseconds.com in case he/she is not satisfied with the response from the Customer Care team. Depending on the query/dispute/grievance, a written reply/resolution will be sent to the customer within 7 business days at his/her registered email id with the Company.`,
    },
    {
      title: "ESCALATIONS",
      content:
        "Level 1: Customers are requested to address all their grievances at the first instance to the Grievance Redressal Officer. A customer not satisfied with the response can escalate the matter/query/complaint to the Grievance Redressal Officer as mentioned hereunder:",
      list: [
        "Name: Ms. Akshita Dalal | Contact Number: 8796755543 | Email ID: grievance@loaninseconds.com",
      ],
      footer:
        "The Grievance Redressal Officer may be reached on the number provided above anytime between 09 AM to 7 PM from Monday to Saturday or through the e-mail address above. The Grievance Redressal Officer shall endeavour to resolve the grievance within a period of seven (7) business days from the date of receipt of a grievance.",
    },
    {
      title: "GRIEVANCE REDRESSAL MECHANISM OF THE LENDER",
      content:
        "For grievances related to the Lender, customers may refer to the Lender's Grievance Redressal Policy available on the Lender's official website. The weblink to the NBFC's Grievance Redressal Policy will be shared on the Platform.",
    },
    {
      title: "CONTACT INFORMATION",
      content: `Please report any concern to the below address:

For General Queries: info@loaninseconds.com
For Existing Customers: support@loaninseconds.com
Phone: 8796755546

Voice Support Hours: ${VOICE_SUPPORT_HOURS}
Customer Support Hours: ${CUSTOMER_SUPPORT_HOURS}`,
    },
  ];

  return (
    <PolicyLayout
      title="Grievance Redressal Policy"
      subtitle={`At ${import.meta.env.VITE_COMPANY_NAME}, every customer voice matters — here's how we listen, resolve, and follow up under the regulatory oversight of ${import.meta.env.VITE_COMPANY_NBFC}.`}
      badge="Customer First 🤝"
    >
      {policySections.map((section, idx) => (
        <div key={idx} className="space-y-6">
          <h2 className="text-2xl font-bold text-[#CC1A1A] tracking-tighter leading-tight">
            {linkifyNbfc(section.title)}
          </h2>

          {section.content && (
            <p className="text-gray-800 text-base leading-relaxed font-semibold whitespace-pre-line">
              {highlightKeyInfo(section.content)}
            </p>
          )}

          {section.list && (
            <ul className="space-y-4">
              {section.list.map((li, i) => (
                <li key={i} className="flex items-start gap-3 text-gray-800 text-base leading-relaxed font-semibold">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#CC1A1A] mt-2.5 flex-shrink-0" />
                  {highlightKeyInfo(li)}
                </li>
              ))}
            </ul>
          )}

          {section.footer && (
            <p className="text-gray-800 text-base leading-relaxed font-semibold whitespace-pre-line">
              {highlightKeyInfo(section.footer)}
            </p>
          )}
        </div>
      ))}
    </PolicyLayout>
  );
};

export default GrievanceRedressalPolicy;
